export default "__VITE_ASSET__400ba0e0__"